<template>
  <div class="base-page">
    <div class="base-page__tab">
      <slot name="tab"></slot>
    </div>
    <div class="base-page__content">
      <slot></slot>
    </div>
  </div>
</template>
<script>

export default {
  name: "BasePage",
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
$color-border1: #d8d8d8; //浅一点的边框。用于分隔输入值
.base-page {
  position: relative;
  background: #fff;
  padding: 22px 0 80px;
  margin-bottom: 80px;
}
.base-page__tab {
  padding: 0 32px;
  border-bottom: 1px solid $color-border1;
  margin-bottom: 24px;
}
.base-page__content {
  padding: 0 32px;
}
.base-page :last-child {
  margin-bottom: 0;
}

</style>


// WEBPACK FOOTER //
// src/components/page/index.vue